
import { Link } from "react-router-dom";

interface CategoryBadgeProps {
  category: string;
  className?: string;
}

export const CategoryBadge = ({ category, className = "" }: CategoryBadgeProps) => {
  // Define category-specific colors
  const getCategoryColor = (category: string) => {
    switch (category.toLowerCase()) {
      case "treatments":
        return "bg-blue-50 text-blue-700 hover:bg-blue-100";
      case "preventive care":
        return "bg-green-50 text-green-700 hover:bg-green-100";
      case "gum health":
        return "bg-purple-50 text-purple-700 hover:bg-purple-100";
      case "medical research":
        return "bg-amber-50 text-amber-700 hover:bg-amber-100";
      case "pediatric dentistry":
        return "bg-pink-50 text-pink-700 hover:bg-pink-100";
      case "patient education":
        return "bg-teal-50 text-teal-700 hover:bg-teal-100";
      default:
        return "bg-dental-accent/20 text-dental-highlight hover:bg-dental-accent/30";
    }
  };

  const categoryColor = getCategoryColor(category);

  return (
    <Link 
      to={`/blog?category=${category}`} 
      className={`inline-block ${categoryColor} px-3 py-1 rounded-full text-xs font-medium transition-colors ${className}`}
    >
      {category}
    </Link>
  );
};
